// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__33r_k","tab":"Tabs_tab__1XZ6E","active":"Tabs_active__FvpRL"};